import { useAuth } from '@/lib/auth-context';

/**
 * Full-screen notice while we auto-open Stripe after signup/login return.
 * Only shown for explicit ?resume_checkout=1 — never force-redirect on a normal visit.
 */
export default function CheckoutResumeOverlay() {
  const { resumingCheckout } = useAuth();

  if (!resumingCheckout) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/80 px-4 backdrop-blur-sm">
      <div className="max-w-sm rounded-2xl border border-white/15 bg-[#121212] px-6 py-8 text-center shadow-2xl">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-[#F04632] border-t-transparent" />
        <p className="text-base font-semibold text-white">Taking you to secure checkout…</p>
        <p className="mt-2 text-sm text-white/55">
          No need to click the plan again — Stripe will open next.
        </p>
      </div>
    </div>
  );
}
